export type AppLocale = 'en' | 'ja' | 'ar';

export const SUPPORTED_LOCALES: AppLocale[] = ['en', 'ja', 'ar'];

export const LOCALE_LABELS: Record<AppLocale, string> = {
  en: 'English',
  ja: '日本語',
  ar: 'العربية',
};

// Short labels used in segmented language pickers where space is tight.
export const LOCALE_SHORT_LABELS: Record<AppLocale, string> = {
  en: 'EN',
  ja: '日本',
  ar: 'عربي',
};

export function normalizeLocale(value: unknown): AppLocale {
  const raw = String(value ?? '').toLowerCase();
  if (raw.startsWith('ja')) return 'ja';
  if (raw.startsWith('ar')) return 'ar';
  return 'en';
}

export function localeDir(locale: AppLocale): 'ltr' | 'rtl' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}

